export class DataSource {
  initialize() {
    return Promise.resolve()
  }
}
export const Between = () => {}
export const Entity = () => {}
export const EventSubscriber = () => {}
export const Index = () => {}
export const Unique = () => {}
export const PrimaryColumn = () => {}
export const PrimaryGeneratedColumn = () => {}
export const Column = () => {}
export const ManyToMany = () => {}
export const ManyToOne = () => {}
export const OneToOne = () => {}
export const JoinColumn = () => {}
export const OneToMany = () => {}
export const JoinTable =  () => {}
export const CreateDateColumn = () => {}
export const UpdateDateColumn = () => {}